import React from 'react';

export const EmptyState = ({ icon: Icon, title, description, action }) => (
  <div className="flex flex-col items-center justify-center text-center py-16 px-6">
    {Icon && (
      <div className="h-14 w-14 rounded-2xl bg-primary/10 flex items-center justify-center mb-4">
        <Icon className="h-7 w-7 text-primary" />
      </div>
    )}
    <h3 className="font-display text-xl font-semibold text-foreground">{title}</h3>
    {description && <p className="mt-1.5 text-sm text-muted-foreground max-w-sm">{description}</p>}
    {action && <div className="mt-5">{action}</div>}
  </div>
);
